const COMPONENT_NAMES = {
  COVERAGE_TYPE_SELECT: 'coverageTypeSelect',
  ASSIGN_DRIVERS: 'assignDrivers',
  ROLES: 'roles',
  YEARS: 'years',
  MAKES: 'makes',
  MODELS: 'models',
  SUBMODELS: 'submodels',
  GPA: 'gpa',
  SELECT_DRIVER: 'selectDriver',
  RADIO: 'radio',
  TEXT: 'text',
  VISUAL_RADIO_GROUP: 'visualRadioGroup',
  DATE: 'date',
  MONTH_YEAR: 'monthYear',
  PHONE: 'phone',
  SSN: 'ssn',
  SELECT: 'select',
  SELECT_WITH_INPUT: 'selectWithInput',
  ADDRESS_AUTOCOMPLETE: 'addressAutocomplete',
  PRIMARY_ADDRESS: 'primaryAddress',
  EFFECTIVE_DATE: 'effectiveDate',
  INFO_TEXT: 'infoText',
  NUMBER: 'number',
  MONEY: 'money',
  STATE_SELECT: 'stateSelect',
  SMS_DISCLAIMER: 'smsDisclaimer',
  TEXTAREA: 'textarea'
};

module.exports = {
  COMPONENT_NAMES
};
